import { Box, ButtonNew, ColorOptions, IconButton, IconNew, Loader, LoaderNew, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { View } from 'react-native'
import { getDropdowntype } from '../../comps/ActionMenu/ActionsMenu'
import { DropdownOptimised } from '../../comps/DropdownNew'
import { DropdownTypes } from '../../comps/DropdownNew/types'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SplitRefundModal } from '../../comps/SplitRefundModal'
import {
  TitleSubtitleLayout,
  TitleSubtitleLayoutColorTheme,
  TitleSubtitleLayoutTypes,
} from '../../comps/TitleSubtitleLayoutNew'
import { dataExport, exportData } from '../../data/static/data'
import { transactionDetailsStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Colors, useWindowDimensions } from '../../util/util'
import { CreateSplitSettlement } from '../TransactionNew/CreateSplitSettlement'
import { styles } from './styles'

interface HeaderProps {
  closeTrxDetailsView?: () => void
  handleOnChange: (value: string | number[]) => void
  ern: string
  rrnValue: string
  onRefund?: () => void
  onExport?: (exportType: string) => void
  path: string
  enableRefund?: boolean
  hide?: boolean
  showExport?: boolean
  isRefunded?: boolean
  txnItem?: any
  refundId?: string
  essSettlementAmount?: number
  isLoading?: boolean
}

const MobileView = (
  viewPortWidth: number,
  ern: string,
  handleOnChange: (value: string | number[]) => void,
  closeTrxDetailsView: () => void,
  onRefund: () => void,
  handleExport: (type: string) => void,
  enableRefund: boolean,
) => {
  const themes = styles(viewPortWidth)

  return (
    <Box {...themes.backgroundColor}>
      <Box {...themes.headerContainer}>
        <Box {...themes.ernContainer}>
          <TitleSubtitleLayout
            type={TitleSubtitleLayoutTypes.HORIZONTAL_BOLD}
            placeHolder={transactionDetailsStrings.headerErn}
            color={TitleSubtitleLayoutColorTheme.READ_ONLY}
            title={ern}
          />
          <Box {...themes.iconStyle}>
            <IconButton
              color={Colors.GREY_C as ColorOptions}
              size={20}
              id={'CLOSE'}
              testID="close-txn-details"
              onPress={closeTrxDetailsView}
            />
          </Box>
        </Box>
        <Spacer size={16} />
        <Box {...themes.exportContainer}>
          <ButtonNew
            {...themes.refundButton}
            title={transactionDetailsStrings.refund}
            onPress={onRefund}
            testID={'refundBtn'}
          />
          <Spacer size={16} direction="horizontal" hide={!enableRefund} />
          <DropdownOptimised
            placeHolder={transactionDetailsStrings.export}
            onChange={handleOnChange}
            data={dataExport}
            onButtonPress={handleExport}
            type={DropdownTypes.RADIO_BUTTON}
          />
        </Box>
      </Box>
      <Box h={2} width="100%" backgroundColor={'SEPERATOR'} />
    </Box>
  )
}

const Header: FC<HeaderProps> = ({
  closeTrxDetailsView = () => {},
  handleOnChange,
  rrnValue,
  ern,
  onRefund = () => {},
  path,
  enableRefund = false,
  hide = false,
  showExport = true,
  isRefunded = false,
  txnItem,
  refundId,
  isLoading = false,
}: HeaderProps) => {
  const { exportSingleTxn, mid, getSplitActionMenuData, isSplitSettlementsEnabled } = useStores((store) => ({
    mid: store.user.selectedMid,
    exportSingleTxn: store.transactions.exportSingleTxnV3,
    getSplitActionMenuData: store.getSplitActionMenuData,
    isSplitSettlementsEnabled: store.settings.metaData.isSplitSettlementsEnabled,
  }))
  const [createSplitVisble, setCreateSplitVisible] = useState(false)

  const [exportTxn, { state }] = useLazyApiData(exportSingleTxn)

  const handleExport = (type: string) => {
    exportTxn(type, path, mid, rrnValue)
  }

  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  if (viewPortWidth < 700) {
    return MobileView(
      viewPortWidth,
      rrnValue,
      handleOnChange,
      closeTrxDetailsView,
      onRefund,
      handleExport,
      enableRefund,
    )
  }

  const dropDownType = getDropdowntype()

  const detailsRootView = document.getElementById('txndetails')
  if (hide) {
    return null
  }

  const actionModalData = getSplitActionMenuData(() => setCreateSplitVisible(true), onRefund, txnItem, path)

  const actionView = (
    <>
      <ModBox
        show={actionModalData?.length === 1}
        flexDirection={'row'}
        ph={12}
        h={34}
        testID={`action-${actionModalData?.[0]?.value}`}
        onPress={() => actionModalData?.[0]?.onPress(txnItem)}
        hoverColor={'TRANSPARENT'}
        underlayColor={'TRANSPARENT'}
        borderRadius={4}
        gap={8}
        borderWidth={0.5}
        align={'center'}
        justify={'space-between'}
        borderColor={'DISABLED_GREY'}>
        <View style={{ transform: [{ rotate: actionModalData?.[0]?.transformAngle }] }}>
          <IconNew
            id={actionModalData?.[0]?.icon as any}
            color={actionModalData?.[0]?.color as ColorOptions}
            size={16}
          />
        </View>
        <Text title={actionModalData?.[0]?.value} fontFamily={'jiotype-medium'} color={'TEXT_PRIMARY'} fontSize={12} />
      </ModBox>
      <ModBox
        show={actionModalData?.length > 1}
        borderWidth={1}
        ph={8}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        h={35}
        align={'center'}
        justify={'center'}>
        <SplitRefundModal data={actionModalData} rowData={txnItem} rootView={detailsRootView} />
      </ModBox>
    </>
  )
  const needHelpAction = () => {
    if (window.trigger_intent_224) {
      const trigger_intent_metadata = {
        need_help_mid: mid,
        need_help_transaction_id: txnItem.id,
      }
      window.trigger_intent_224(trigger_intent_metadata)
    }
  }
  return (
    <Box {...themes.backgroundColor}>
      <Box {...themes.headerContainer}>
        <Box flexDirection="row" justifyContent="space-between">
          <Box justifyContent={'center'} flex={1}>
            <Box>
              <Box {...themes.ernContainer}>
                <Text fontFamily="jiotype-bold" type={'h3Bold'} color={'PRIMARY_GREY'}>
                  {transactionDetailsStrings.headerErn}
                </Text>
                <Box f={1}>
                  <Text fontFamily="jiotype-medium" type={'subheading'} wordBreak="break-word" color={'BLACK'}>
                    {ern}
                  </Text>
                </Box>
              </Box>
              <ModBox
                show={txnItem?.essStatus === 'PAYOUT_SPLIT_INITIATED' && isSplitSettlementsEnabled}
                flexDirection={'row'}
                align={'center'}
                gap={8}>
                <View style={{ transform: [{ rotate: '90deg' }] }}>
                  <IconNew id={'SPLIT'} color={'#9501B0' as ColorOptions} size={16} />
                </View>
                <Text fontFamily="jiotype-medium" numberOfLines={1} color={'PRIMARY_GREY'}>
                  {'Split Transaction'}
                </Text>
              </ModBox>
            </Box>
            {isRefunded && (
              <Box
                backgroundColor={'#C977161A' as ColorOptions}
                paddingVertical={3}
                paddingHorizontal={5}
                alignSelf={'flex-start'}>
                <Text fontSize={12} fontFamily="jiotype-medium" color="#C97716">
                  Refunded
                </Text>
              </Box>
            )}
          </Box>
          <Box {...themes.exportContainer}>
            {isLoading ? <LoaderNew color={'BLUE'} /> : actionView}
            {createSplitVisble && (
              <CreateSplitSettlement
                visible={createSplitVisble}
                data={txnItem}
                refundId={refundId}
                close={() => setCreateSplitVisible(false)}
              />
            )}
            <Spacer size={16} direction="horizontal" />
            <Spacer size={16} direction="horizontal" />
            <DropdownOptimised
              hide={state === 'pending' || !showExport}
              placeHolder={transactionDetailsStrings.export}
              onChange={handleOnChange}
              data={exportData(true)}
              onButtonPress={handleExport}
              type={dropDownType.exportModalType}
              testID={'exportBtn'}
            />
            <ModBox show={state === 'pending'} w={82}>
              <Loader type="small" />
            </ModBox>
            <Spacer size={16} direction="horizontal" />
            <Box {...themes.iconStyle}>
              <IconButton
                testID={'closeDetails'}
                size={20}
                color={Colors.GREY_C as ColorOptions}
                id={'CLOSE'}
                onPress={closeTrxDetailsView}
              />
            </Box>
          </Box>
        </Box>
        <Spacer size={8} />
        <ModBox
          ph={12}
          h={34}
          testID={'action-Need help'}
          onPress={needHelpAction}
          hoverColor={'TRANSPARENT'}
          underlayColor={'TRANSPARENT'}
          borderRadius={4}
          gap={8}
          borderWidth={0.5}
          marginRight={56}
          alignItems={'center'}
          alignSelf={'flex-start'}
          justifyContent={'center'}
          borderColor={'DISABLED_GREY'}>
          <Text title={'Need Help'} fontFamily={'jiotype-medium'} color={'TEXT_PRIMARY'} fontSize={12} />
        </ModBox>
      </Box>
      <Box h={2} width="100%" backgroundColor={'SEPERATOR'} />
    </Box>
  )
}

export default Header
